/**
 * PublicRoute Component
 * Route wrapper for public pages (accessible without authentication)
 */

import React from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuthStore } from "@/features/auth/store/authStore";
import { TERMINAL_ROUTES } from "@/features/terminal/routes";

interface PublicRouteProps {
  children?: React.ReactNode;
  redirectIfAuthenticated?: boolean;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectIfAuthenticated = true,
}) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  // If user is authenticated and we should redirect, go to terminal
  if (isAuthenticated && redirectIfAuthenticated) {
    const from =
      (location.state as { from?: string })?.from || TERMINAL_ROUTES.HOME;
    return <Navigate to={from} replace />;
  }

  return <>{children || <Outlet />}</>;
};

export default PublicRoute;
